import React from 'react'
import { BaseSchema } from '../../../Schema/BaseSchema'
import { ConsigneePicker } from '../../../App/Consignees/Components/ConsigneePicker'
import { ConsigneeType } from '../../../Schema/ConsigneeSchema'

interface SchemaConsigneePickerProps {
  consigneeType?: ConsigneeType
  className?: any
  schema: BaseSchema
  label?: string
  field?: string
  helperText?: string
  onChange: Function
  disabled?: boolean
  required?: boolean
  variant?: 'standard' | 'filled' | 'outlined'
  placeholder?: string
  freeSolo?: boolean
  noOptionsText?: string
  clearOnBlur?: boolean
  enableCreate?: boolean
  showAvatar?: boolean
}

export const SchemaConsigneePicker: React.FC<SchemaConsigneePickerProps> = ({
  consigneeType,
  className,
  schema,
  field = 'consigneeId',
  label = 'Consignee',
  helperText,
  onChange = (value: string, field: string) => {},
  disabled,
  required,
  variant,
  placeholder = 'Select a Consignee',
  freeSolo,
  noOptionsText,
  clearOnBlur,
  enableCreate,
  showAvatar = false,
}) => {
  return (
    <ConsigneePicker
      consigneeType={consigneeType}
      className={className}
      label={label}
      onChange={value => onChange(value, field)}
      disabled={disabled}
      required={required}
      variant={variant}
      placeholder={placeholder}
      freeSolo={freeSolo}
      noOptionsText={noOptionsText}
      clearOnBlur={clearOnBlur}
      enableCreate={enableCreate}
      error={schema.isPropertyInvalid(field)}
      helperText={schema.isPropertyInvalid(field) ? schema.getPropertyError(field) : helperText }
      value={schema.getValue(field) || null}
      showAvatar={showAvatar}
    />
  )
}
